export default "__VITE_ASSET__DsYmeSvZ__"